import React, { useMemo, useState } from 'react';
import TourCard from '../components/TourCard';
import SubscribeBlock from '../components/SubscribeBlock';
import './LuxuryPackagesPage.css';

const LuxuryPackagesPage = () => {
  const allTours = useMemo(() => [
    { image: 'experience-1.png', country: 'Австрия', title: 'Зимний парк для лыжного отдыха', price: 1490, rating: 4.8 },
    { image: 'experience-2.png', country: 'Перу', title: 'Мачу-Пикчу', price: 2500, rating: 4.9 },
    { image: 'experience-3.png', country: 'Хорватия', title: 'Хвар', price: 4500, rating: 4.9 },
    { image: 'experience-4.jpg', country: 'Иордания', title: 'Вади-Муса', price: 4500, rating: 4.7 },
    { image: 'experience-1.png', country: 'Турция', title: 'Анталия, пляжный отдых', price: 890, rating: 4.8 },
    { image: 'experience-2.png', country: 'ОАЭ', title: 'Дубай, город и море', price: 1200, rating: 4.9 },
    { image: 'experience-3.png', country: 'Египет', title: 'Sharm El Sheikh', price: 750, rating: 4.7 },
    { image: 'experience-4.jpg', country: 'Таиланд', title: 'Пхукет', price: 1100, rating: 4.8 },
    { image: 'experience-1.png', country: 'Мальдивы', title: 'Островной отдых', price: 3200, rating: 5.0 },
    { image: 'experience-2.png', country: 'Италия', title: 'Рим и Флоренция', price: 980, rating: 4.9 },
    { image: 'experience-3.png', country: 'Испания', title: 'Барcelona & Costa Brava', price: 870, rating: 4.8 },
    { image: 'experience-4.jpg', country: 'Грузия', title: 'Тбилиси и Батуми', price: 650, rating: 4.9 },
  ], []);

  const [visibleCount, setVisibleCount] = useState(9);
  const visibleTours = allTours.slice(0, visibleCount);

  return (
    <main className="lp-root">
      <section className="lp-title-band">
        <div className="page-container">
          <h1 className="lp-title">Премиальные пакеты</h1>
          <p className="lp-subtitle">Подборка популярных направлений — выберите тур и оставьте заявку.</p>
        </div>
      </section>

      <section className="lp-grid-wrap">
        <div className="lp-cards-grid">
          {visibleTours.map((tour, i) => (
            <TourCard key={`${tour.title}-${i}`} {...tour} />
          ))}
        </div>
        {visibleCount < allTours.length && (
          <div className="lp-more">
            <button type="button" onClick={() => setVisibleCount((c) => c + 3)}>
              Загрузить ещё
            </button>
          </div>
        )}
      </section>

      <SubscribeBlock />
    </main>
  );
};

export default LuxuryPackagesPage;
